export const GET_CROP_VALUES = 'getCropValues';
export const DELETE_IMAGE = 'deleteImage';
